import { isNaN } from 'lodash';

export const CustomRender = {
	name: "custom-render",
	functional: true,
	props: {
		row: Object,
		render: Function,
		index: Number,
		column: {
			type: Object,
			default: null
		}
	},
	render: (h, ctx) => {
		const params = {
			row: ctx.props.row,
			index: ctx.props.index
		};
		if (ctx.props.column) params.column = ctx.props.column;
		return ctx.props.render(h, params);
	}
};

export const applyDrag = (arr, dragResult) => {
	const { removedIndex, addedIndex, payload } = dragResult;
	if (removedIndex === null && addedIndex === null) return arr;

	const result = [...arr];
	let itemToAdd = payload;

	if (removedIndex !== null) {
		itemToAdd = result.splice(removedIndex, 1)[0];
	}

	if (addedIndex !== null) {
		result.splice(addedIndex, 0, itemToAdd);
	}

	return result;
};

export const editorToolbar = [
	["bold", "italic", "underline", "strike"],
	[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
	["blockquote", "code-block", "link"],
	[
		{ align: "" },
		{ align: "center" },
		{ align: "right" },
		{ align: "justify" }
	],
	[{ header: 1 }, { header: 2 }],
	[{ color: [] }, { background: [] }],
	["clean"]
];

export const editorToolbarMin = [
	["bold", "italic", "underline"],
	[{ list: "ordered" }, { list: "bullet" }],
	[
		{ align: "" },
		{ align: "center" },
		{ align: "right" },
		{ align: "justify" }
	],
	[{ color: [] }, { background: [] }],
	["clean"]
];

export const parseJSON = str => {
	try {
		return JSON.parse(str);
	} catch (e) {
		return false;
	}
};

export const consultarCEP = async cep => {
	const cepNum = cep ? cep.match(/\d+/gi).join("") : {};
	if (cepNum.length !== 8) return false;
	try {
		const response = await fetch(`//viacep.com.br/ws/${cepNum}/json/`);
		const data = await response.json();
		if (data.erro) return false;
		return data;
	} catch (err) {
		return false;
	}
};

export const UCfirst = str => str.charAt(0).toUpperCase() + str.slice(1);

export const toQueryString = obj =>
	obj
		? Object.keys(obj)
			.map(
				key => obj[key] !== '' && `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
			)
			.filter(Boolean)
			.join('&')
		: '';

export const formatoGrafico = (valor, negativo = false) => {
	valor = parseFloat(valor);
	if (negativo === true) {
		return isNaN(valor) ? 0.0 : parseFloat((valor * -1).toFixed(2));
	} else {
		return isNaN(valor) ? 0.0 : parseFloat(valor.toFixed(2));
	}
};

const moment_ = require('moment');
require('moment/locale/pt-br');
moment_.locale('pt-br');

export const moment = moment_;

const rand = () => Math.random().toString(36).substr(2);

export const genToken = () => rand() + rand();

export const formataTempo = (tempo) => {
	let tempo_formatado = "";
	tempo_formatado +=  (tempo._data.years >0) ? ((tempo._data.years >1) ? tempo._data.years+" anos, " : tempo._data.years+" ano, " ): "";
	tempo_formatado +=  (tempo._data.months >0) ? ((tempo._data.months > 1) ? tempo._data.months+" meses, " : tempo._data.months+" mês, " ): "";
	tempo_formatado +=  (tempo._data.days >0) ? ((tempo._data.days >1) ? tempo._data.days+" dias, " : tempo._data.days+" dia, " ): "";
	tempo_formatado +=  (tempo._data.hours >0) ? ((tempo._data.hours >1) ? tempo._data.hours+" horas, " : tempo._data.hours+" hora, " ): "";
	tempo_formatado +=  (tempo._data.minutes >0) ? ((tempo._data.minutes >1) ? tempo._data.minutes+" minutos " : tempo._data.minutes+" minuto " ): "";
	return tempo_formatado;
};
